<template>
  <page-header-wrapper>
    <a-space direction="vertical" style="width: 100%">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-card :loading="loading" title="CPU" :bordered="false">
            <a-row :gutter="24" v-if="server.cpu">
              <a-col :span="12">
                <a-space direction="vertical" size="large">
                  <a-statistic
:title="$tt('核心数')"
                    :value="server.cpu.cpuNum"
                    :value-style="{ color: '#3f8600' }"
                    style="margin-right: 50px"
                  >
                    <template #prefix>
                      <a-icon type="setting" />
                    </template>
                  </a-statistic>
                  <a-statistic
:title="$tt('用户使用率')"
                    :value="server.cpu.used"
                    :precision="2"
                    suffix="%"
                    :value-style="{ color: '#3f8600' }"
                    style="margin-right: 50px"
                  >
                    <template #prefix>
                      <a-icon type="team" />
                    </template>
                  </a-statistic>
                </a-space>
              </a-col>
              <a-col :span="12">
                <a-space direction="vertical" size="large">
                  <a-statistic
:title="$tt('系统使用率')"
                    :value="server.cpu.sys"
                    :precision="2"
                    suffix="%"
                    :value-style="{ color: '#3f8600' }"
                    style="margin-right: 50px"
                  >
                    <template #prefix>
                      <a-icon type="cloud-server" />
                    </template>
                  </a-statistic>
                  <a-statistic
:title="$tt('当前空闲率')"
                    :value="server.cpu.free"
                    :precision="2"
                    suffix="%"
                    :value-style="{ color: '#3f8600' }"
                    style="margin-right: 50px"
                  >
                    <template #prefix>
                      <a-icon type="inbox" />
                    </template>
                  </a-statistic>
                </a-space>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card :loading="loading" :title="$tt('内存')" :bordered="false">
            <a-table
              :loading="loading"
              size="small"
              rowKey="name"
              :columns="memColumns"
              :data-source="memData"
              :pagination="false">
              <span slot="mem" slot-scope="text, record">
                <div :style="{color: record.name == $tt('使用率') &amp;&amp; text > 80 ? 'red' : ''}">
                  <a-icon type="warning" style="color:#FFCC00" v-if="record.name == $tt('使用率') &amp;&amp; text > 80" />
                  {{ text }} &nbsp;
                  <code v-if="record.name == $tt('使用率')">%</code>
                  <code v-if="record.name != $tt('使用率')">G</code>
                </div>
              </span>
              <span slot="jvm" slot-scope="text, record">
                <div :style="{color: record.name == $tt('使用率') &amp;&amp; text > 80 ? 'red' : ''}">
                  <a-icon type="warning" style="color:#FFCC00" v-if="record.name == $tt('使用率') &amp;&amp; text > 80" />
                  {{ text }} &nbsp;
                  <code v-if="record.name == $tt('使用率')">%</code>
                  <code v-if="record.name != $tt('使用率')">M</code>
                </div>
              </span>
            </a-table>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-card :loading="loading" :title="$tt('服务器信息')" :bordered="false">
            <a-descriptions :column="2" v-if="server.sys">
              <a-descriptions-item :label="$tt('服务器名称')">
                {{ server.sys.computerName }}
              </a-descriptions-item>
              <a-descriptions-item :label="$tt('操作系统')">
                {{ server.sys.osName }}
              </a-descriptions-item>
              <a-descriptions-item :label="$tt('服务器IP')">
                {{ server.sys.computerIp }}
              </a-descriptions-item>
              <a-descriptions-item :label="$tt('系统架构')">
                {{ server.sys.osArch }}
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-card :loading="loading" :title="$tt('Java虚拟机信息')" :bordered="false">
            <a-descriptions :column="2" v-if="server.jvm">
              <a-descriptions-item :label="$tt('Java名称')">
                {{ server.jvm.name }}
              </a-descriptions-item>
              <a-descriptions-item :label="$tt('Java版本')">
                {{ server.jvm.version }}
              </a-descriptions-item>
              <a-descriptions-item :label="$tt('启动时间')">
                {{ server.jvm.startTime }}
              </a-descriptions-item>
              <a-descriptions-item :label="$tt('运行时长')">
                {{ server.jvm.runTime }}
              </a-descriptions-item>
              <a-descriptions-item :label="$tt('安装路径')">
                {{ server.jvm.home }}
              </a-descriptions-item>
              <a-descriptions-item :label="$tt('项目路径')">
                {{ server.sys.userDir }}
              </a-descriptions-item>
              <a-descriptions-item :label="$tt('运行参数')">
                {{ server.jvm.inputArgs }}
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-card :loading="loading" :title="$tt('磁盘状态')" :bordered="false">
            <a-table
              :loading="loading"
              :size="tableSize"
              rowKey="dirName"
              :columns="sysColumns"
              :data-source="sysData"
              :pagination="false"
              :bordered="tableBordered"
            >
              <span slot="total" slot-scope="text">
                {{ text }}
              </span>
              <span slot="free" slot-scope="text">
                {{ text }}
              </span>
              <span slot="used" slot-scope="text">
                {{ text }}
              </span>
              <span slot="usage" slot-scope="text">
                <div :style="{color: text > 80 ? 'red' : ''}">
                  <a-icon type="warning" style="color:#FFCC00" v-if="text > 80" />
                  {{ text }}<code>%</code>
                </div>
              </span>
            </a-table>
          </a-card>
        </a-col>
      </a-row>
    </a-space>
  </page-header-wrapper>
</template>

<script>
import { translateText } from '@/locales/text'


import { getServer } from '@/api/monitor/server'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Server',
  mixins: [tableMixin],
  data () {
    return {
      server: [],
      loading: true,
      memColumns: [
        {
          get title () { return translateText('属性') },
          dataIndex: 'name'
        },
        {
          get title () { return translateText('内存') },
          dataIndex: 'mem',
          scopedSlots: { customRender: 'mem' }
        },
        {
          title: 'JVM',
          dataIndex: 'jvm',
          scopedSlots: { customRender: 'jvm' }
        }
      ],
      memData: [],
      sysColumns: [
        {
          get title () { return translateText('盘符路径') },
          dataIndex: 'dirName',
          ellipsis: true
        },
        {
          get title () { return translateText('文件系统') },
          dataIndex: 'sysTypeName'
        },
        {
          get title () { return translateText('盘符类型') },
          dataIndex: 'typeName',
          ellipsis: true
        },
        {
          get title () { return translateText('总大小') },
          dataIndex: 'total',
          scopedSlots: { customRender: 'total' }
        },
        {
          get title () { return translateText('可用大小') },
          dataIndex: 'free',
          scopedSlots: { customRender: 'free' }
        },
        {
          get title () { return translateText('已用大小') },
          dataIndex: 'used',
          scopedSlots: { customRender: 'used' }
        },
        {
          get title () { return translateText('已用百分比') },
          dataIndex: 'usage',
          scopedSlots: { customRender: 'usage' }
        }
      ],
      sysData: []
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询服务信息 */
    getList () {
      // this.loading = true
      getServer().then(response => {
          const serverData = response.data
          this.server = serverData
          this.memData = [
            {
              name: translateText('总内存'),
              mem: serverData.mem.total,
              jvm: serverData.jvm.total
            },
            {
              name: translateText('已用内存'),
              mem: serverData.mem.used,
              jvm: serverData.jvm.used
            },
            {
              name: translateText('剩余内存'),
              mem: serverData.mem.free,
              jvm: serverData.jvm.free
            },
            {
              name: translateText('使用率'),
              mem: serverData.mem.usage,
              jvm: serverData.jvm.usage
            }
          ]
          this.sysData = serverData.sysFiles
          setTimeout(() => {
            this.loading = false
          }, 500)
        }
      )
    }
  }
}
</script>
